<script>
import Multiselect from "@vueform/multiselect";
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { GanttComponent, Selection, DayMarkers, Toolbar, ExcelExport, PdfExport } from "@syncfusion/ej2-vue-gantt";
import api from "@/axios";
import Swal from "sweetalert2";
import Loader from "@/router/views_mobagile/components/loader.vue";
import moment from "moment";
import {recordClick} from "@syncfusion/ej2-vue-grids";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader, Layout, PageHeader, Multiselect,
    'ejs-gantt': GanttComponent
  },
  data() {

    return {
      title: "Gestão de Projeto (Implantação)",
      items: [
        {
          text: "Projetos",
          href: "/"
        },
        {
          text: "Gestão de Projeto (Implantação)",
          active: true
        }
      ],
      idData: 0,
      showModalProjTask: false,
      submittedTarefa: false,
      resourcesData: null,
      projResourcesData: null,
      projTasksDataTodas: null,
      projTasksData: null,
      projTaskData: {
        atribuido: null
      },
      updating: true,
      dtListPesqResource: null,
      resourcesTaskData: {},
      resourceData: {},
      loadingResource: false,
      novoRecurso: false,

      showModalProjMarker: false,
      novoMarker: false,
      loadingMarkers: false,
      projMarkersData: null,
      projMarkerData: {},
      submittedMarker: false,

      dependenceData: {},
      dependencesTaskData: {},
      novaDependencia: false,
      dtListPesqDependence: null,

      projIndicatorsData: {},
      projIndicatorData: {
        icone: null
      },
      novoIndicator: false,
      submittedIndicator: false,
      activeTab: 0,
      projSubTasksData: {},
      projSubTaskData: {},
      novaSubTask: false,
      dtListPesqSubTask: null,
      errosValid: null,
      paramDownArqProj: null,
      flagSubTarefa: false,
      flagVisualTask: false,

      projectStartDate: new Date(moment().subtract(1, 'months').format('MM/DD/YYYY')),
      projectEndDate: new Date(moment().add(1, 'months').format('MM/DD/YYYY')),
      toolbar: [
        { text: 'Download', tooltipText: 'Download Arquivo', id: 'downVisio', prefixIcon: 'e-icons  e-download' },
        { text: 'Nova Tarefa', tooltipText: 'Nova Tarefa', id: 'novaTarefa', prefixIcon: 'e-icons  e-plus' },
        { text: 'Recursos', tooltipText: 'Recursos', id: 'abrirRecursos', prefixIcon: 'e-icons  e-between' },
        { text: 'Marcadores', tooltipText: 'Marcadores', id: 'abrirMarkers', prefixIcon: 'e-icons  e-fixed-column-width' },
        'ExpandAll', 'CollapseAll', "ExcelExport", "CsvExport", "PdfExport", "ZoomIn", "ZoomOut", "ZoomToFit"
      ],

      taskFields: {
        id: 'id',
        name: 'descricao',
        startDate: 'inicioViz',
        endDate: 'fimViz',
        duration: 'duracao',
        progress: 'progresso',
        dependency: 'dependences',
        resourceInfo: 'resources',
        baselineStartDate: 'inicioexecViz',
        baselineEndDate: 'fimexecViz',
        notes: 'priorid',
        child: 'subtasks'
      },
      columns: [
        // { field: 'id', headerText: 'ID', width: 50, textAlign: 'Left'  },
        { field: 'codigo', headerText: 'Código', width: 100, textAlign: 'Left'  },
        { field: 'status', headerText: 'Status', width: 110, textAlign: 'Left'  },
        { field: 'descricao', headerText: 'Descrição', width: 230 },
        { field: 'inicioF', headerText: 'Início', width: 90 },
        { field: 'fimF', headerText: 'Fim', width: 90 },
        { field: 'duracao', headerText: 'Duração', width: 90, textAlign: 'Right' },
        { field: 'progresso', headerText: 'Progresso', textAlign: 'Right' }
      ],
      resourceFields: {
        id: 'id',
        descricao: 'descricao'
      },
      labelSettings: {
        leftLabel: "leftLabelTemplate",
        rightLabel: "rightLabelTemplate",
        taskLabel: '${progresso}%'
      },
      splitterSettings: {
        position: "30%"
      },

    };
  },

  created() {

  },

  computed: {

    inicioLocal: {
      get() {
        return this.toInputFormat(this.projTaskData.inicio);
      },
      set(value) {
        this.projTaskData.inicio = new Date(value).toISOString();
      }
    },
    fimLocal: {
      get() {
        return this.toInputFormat(this.projTaskData.fim);
      },
      set(value) {
        this.projTaskData.fim = new Date(value).toISOString();
      }
    }, inicioexecLocal: {
      get() {
        return this.toInputFormat(this.projTaskData.inicioexec);
      },
      set(value) {
        this.projTaskData.inicioexec = new Date(value).toISOString();
      }
    },
    fimexecLocal: {
      get() {
        return this.toInputFormat(this.projTaskData.fimexec);
      },
      set(value) {
        this.projTaskData.fimexec = new Date(value).toISOString();
      }
    },

    gradientProgressStyle() {
      const progress = Math.max(0, Math.min(100, this.projTaskData.progresso || 0));

      return {
        backgroundImage: 'linear-gradient(to right, #b8fae3, #34c18e)',
        backgroundSize: `${progress}% 100%`,
        backgroundColor: '#fff',
        backgroundRepeat: 'no-repeat',
        transition: 'background-size 0.3s ease',
      };
    },

    iconPriorid() {
      const priorid = this.projTaskData.priorid;

      switch (priorid) {
        case 'baixa':
          return {color: '#77b8f1'}
        case 'normal':
          return {color: '#056fcd'}
        case 'media':
          return {color: '#f6aa27'}
        case 'alta':
          return {color: '#faaabd'}
        case 'critica':
          return {color: '#cc0707'}

        default:
          return {
            color: '#fff'
          }
      }
    },

    variantStatus() {
      const stt = this.projTaskData.status;

      switch (stt) {
        case 'pending':
          return {text: 'Concluído', color: '#faaabd'}
        case 'inprocess':
          return {text: 'Em Andamento', color: '#7cbcf6'}
        case 'completed':
          return {text: 'Pendente', color: '#34c18e'}
        default:
          return {text: 'Desconhecido', color: '#fff'}
      }
    },
  },

  mounted() {
    console.log('then axios mountedGestaoProjeto')
    this.carregarDados()
  },

  provide: {
    gantt: [DayMarkers, Selection, Toolbar, ExcelExport, PdfExport]
  },


  methods: {
    recordClick() {
      return recordClick
    },

    customizaCelula(args) {
      if (args.column.field === 'status' && args.data.status) {
        const valor = args.data.status.toLowerCase();
        let nomeStatus = valor;
        switch (valor) {
          case 'pending':
            args.cell.style.backgroundColor = '#faaabd';
            args.cell.style.color = '#7c1a1a';
            nomeStatus = 'Pendente';
            break;
          case 'inprocess':
            args.cell.style.backgroundColor = '#7cbcf6';
            args.cell.style.color = '#124371';
            nomeStatus = 'Em andamento'
            break;
          case 'completed':
            args.cell.style.backgroundColor = '#34c18e';
            args.cell.style.color = '#085905';
            nomeStatus = 'Concluído'
            break;
        }

        args.cell.innerText = nomeStatus;
      }
    },

    queryTaskbarInfo(args) {
      // console.log('queryTaskbarInfo args')
      // console.log(args.data.ganttProperties.notes)
      if (args.data.ganttProperties.notes) {
        var resourceName = args.data.ganttProperties.notes;
        if (resourceName === 'baixa') {
          args.taskbarBgColor = '#adadad';
          args.progressBarBgColor = '#6b6b6b';
          if (args.data.ganttProperties.progress === 0) {
            args.taskLabelColor = 'black';
          }
        } else if (resourceName === 'normal') {
          args.taskbarBgColor = '#87b972';
          args.milestoneColor = '#87b972';
          args.progressBarBgColor = '#4a7537';
          args.taskbarBorderColor = '#4a7537';
          if (args.data.ganttProperties.progress === 0) {
            args.taskLabelColor = 'black';
          }
        } else if (resourceName === 'media') {
          args.taskbarBgColor = '#a496cf';
          args.milestoneColor = '#a496cf';
          args.progressBarBgColor = '#635688';
          args.taskbarBorderColor = '#635688';
          if (args.data.ganttProperties.progress === 0) {
            args.taskLabelColor = 'black';
          }
        } else if (resourceName === 'alta') {
          args.taskbarBgColor = '#ef6fbb';
          args.milestoneColor = '#ef6fbb';
          args.progressBarBgColor = '#a53576';
          args.taskbarBorderColor = '#a53576';
          if (args.data.ganttProperties.progress === 0) {
            args.taskLabelColor = 'black';
          }
        } else if (resourceName === 'critica') {
          args.taskbarBgColor = '#ff826b';
          args.milestoneColor = '#ff826b';
          args.progressBarBgColor = '#b24531';
          args.taskbarBorderColor = '#b24531';
          if (args.data.ganttProperties.progress === 0) {
            args.taskLabelColor = 'black';
          }
        }
      }
    },


    newSubTarefa(){
      console.log('newSubTarefa')
      this.flagSubTarefa = true;
      this.projTaskData = {
        priorid: "normal",
        status: "pending",
        codigo: this.projTaskData.codigo,
        inicio: moment(new Date()).format("yyyy-MM-DDThh:mm"),
        fim: moment(new Date()).add(1, 'days').format("yyyy-MM-DDThh:mm")
      }
      this.novoIndicator = false
      this.novaDependencia = false
      this.novoRecurso = false
      this.novoMarker = false
      this.novaSubTask = false

      /*console.log('moment(new Date())')
      console.log(moment(new Date()).format("yyyy-MM-DDThh:mm"))*/

      this.submittedTarefa = false
      this.showModalProjTask = true
    },

    editMarker(dataMarker){
      console.log('editMarker')
      console.log(dataMarker.data)
      this.projMarkerData = dataMarker
      this.projMarkerData.data = moment(dataMarker.data).format("YYYY-MM-DD")
      this.novoMarker = true
    },

    confProjMarker(){
      console.log('confProjMarker')
      this.submittedMarker = true
      if (this.projMarkerData.descricao && this.projMarkerData.data) {
        this.showModalProjMarker = false
        this.updating = true
        api.post(`${getBaseUrl()}api/projmarker`, {
          'projMarkerData': this.projMarkerData
        }).then((res) => {
          console.log('then axios confProjMarker')
          console.log(res.data)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },


    delResource(idData){
      console.log('delResource')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Exclusão de Recurso ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingResource = true
          api.delete(`${getBaseUrl()}api/projresource`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarResources()
          })
        }
      })
    },

    delDependence(idData){
      console.log('delDependence')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Exclusão de Dependência ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingResource = true
          api.delete(`${getBaseUrl()}api/projdependence`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarResources()
          })
        }
      })
    },

    delIndicator(idData){
      console.log('delIndicator')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Exclusão de Indicador ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingResource = true
          api.delete(`${getBaseUrl()}api/projindicator`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarResources()
          })
        }
      })
    },

    detalhesSubTask(idData){
      console.log('detalhesSubTask')
      // console.log('detalhesSubTask: ' + idData)
      this.flagVisualTask = true;

      this.projTasksDataTodas.forEach((value) => {
        if (idData === value.id) {
          // console.log(value.inicio)
          this.projTaskData = value
        }
      })

      this.showModalprojTask = true
      // console.log('this.projTaskData: ' , this.projTaskData)
    },

    editarSubTask(idData){
      console.log('editarSubTask')
      // console.log('editarSubTask: ' + idData)
      this.flagSubTarefa = true

      this.projTasksDataTodas.forEach((value) => {
        if (idData === value.id) {
          // console.log(value.inicio)
          this.projTaskData = value
        }
      })

      this.showModalprojTask = true
    },



    delSubTask(idData){
      console.log('delSubTask')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Exclusão de Sub-Tarefa ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingResource = true
          api.delete(`${getBaseUrl()}api/projsubtask`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarResources()
          })
        }
      })
    },

    delMarker(idData){
      console.log('delMarker')
      console.log('deletar_0: ' + idData)
      this.showModalProjMarker = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Exclusão de Marcador ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projmarker`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
          })
        }
      })
    },

    delProjTask(idData){
      console.log('delProjTask')
      console.log('deletar_0: ' + idData)
      this.showModalProjTask = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Exclusão de Tarefa ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projtask`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    escolheuResource(){
      console.log('escolheuResource')
      this.loadingResource = true
      this.resourceData.projtask_id = this.projTaskData.id
      api.post(`${getBaseUrl()}api/projresource`, {
        'resourceData': this.resourceData
      }).then((res) => {
        console.log('then axios resourceData')
        console.log(res.data)
        this.novoRecurso = false
        this.resourceData = {}
        this.dtListPesqResource = null
        this.carregarResources()
      })
    },

    escolheuDependence(){
      console.log('escolheuDependence')
      this.loadingResource = true
      this.dependenceData.projtask_id = this.projTaskData.id
      api.post(`${getBaseUrl()}api/projdependence`, {
        'dependenceData': this.dependenceData
      }).then((res) => {
        console.log('then axios resourceData')
        console.log(res.data)
        this.novaDependencia = false
        this.dependenceData = {}
        this.dtListPesqDependence = null
        this.carregarResources()
      })
    },

    escolheuSubTask(){
      console.log('escolheuSubTask')
      console.log(this.projSubTaskData)
      this.loadingResource = true
      this.projSubTaskData.projtask_id = this.projTaskData.id
      api.post(`${getBaseUrl()}api/projsubtask`, {
        'projSubTaskData': this.projSubTaskData
      }).then((res) => {
        console.log('then axios resourceData')
        console.log(res.data)
        this.novaSubTask = false
        this.projSubTaskData = {}
        this.dtListPesqSubTask = null
        this.carregarResources()
      })
    },


    pesqSubTask(evt){
      console.log('pesqSubTask')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/subtaskpesq`, {
          params: { q: query, idtask: this.projTaskData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqSubTask = res.data
        });
      }
    },

    pesqResource(evt){
      console.log('pesqResource')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/resourcepesq`, {
          params: { q: query, idtask: this.projTaskData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqResource = res.data
        });
      }
    },

    pesqDependence(evt){
      console.log('pesqDependence')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/dependencepesq`, {
          params: { q: query, idtask: this.projTaskData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqDependence = res.data
        });
      }
    },


    carregarDados() {
      api.get(`${getBaseUrl()}api/gestaoprojeto`).then((res) => {
        console.log('then axios gestaoProjeto')
        console.log(res.data)
        let todasTarefas = res.data[0]
        let todasSubTarefas = res.data[6]
        let todasTarefasFilt = []
        todasTarefas.forEach((valueT) => {
          let subTasks = []
          let ehSubTarefa = false
          todasSubTarefas.forEach((valueS) => {
            // console.log('value0S')
            // console.log(value0S)
            if (valueT.id === valueS.projsubtask_id) {
              ehSubTarefa = true
            }

            if (valueT.id === valueS.projtask_id) {
              todasTarefas.forEach((valueTS) => {
                if (valueTS.id === valueS.projsubtask_id) {
                  subTasks.push(valueTS)
                }
              })
            }
          })
          valueT.subtasks = subTasks
          if (!ehSubTarefa) {
            todasTarefasFilt.push(valueT)
          }

        })

        this.projTasksDataTodas = res.data[0]
        this.projTasksData = todasTarefasFilt
        this.projResourcesData = res.data[1]
        this.resourcesData = res.data[2]
        this.projMarkersData = res.data[3]
        this.dependencesTaskData = res.data[4]
        this.projIndicatorsData = res.data[5]
        this.paramDownArqProj = res.data[7]
        this.projTasksData.forEach((value) => {
          value.inicioF = moment(value.inicio).format("DD/MM/YYYY")
          value.fimF = moment(value.fim).format("DD/MM/YYYY")
          value.inicioFed = moment(value.inicio).format("yyyy-MM-DDThh:mm")
          value.fimFed = moment(value.fim).format("yyyy-MM-DDThh:mm")
          value.inicioViz = new Date(moment(value.inicio).format("MM/DD/yyyy"))
          value.fimViz = new Date(moment(value.fim).format("MM/DD/yyyy"))
          if (value.inicioexec) {
            value.inicioexecFed = moment(value.inicioexec).format("yyyy-MM-DDThh:mm")
            value.inicioexecViz = new Date(moment(value.inicioexec).format("MM/DD/yyyy"))
          }
          if (value.fimexec) {
            value.fimexecFed = moment(value.fimexec).format("yyyy-MM-DDThh:mm")
            value.fimexecViz = new Date(moment(value.fimexec).format("MM/DD/yyyy"))
          }
          value.duracao = null // se colocar valor e exibição da barra no gantt vai desconfigurar, colocando null vai seguir a data fim

          let resLoc = []
          this.projResourcesData.forEach((valueRes) => {
            if (valueRes.projtask_id === value.id) {
              // console.log('valueRes')
              // console.log(valueRes)
              resLoc.push(valueRes.resource_id)
            }
          })
          value.resources = resLoc

          let depsLoc = ''
          this.dependencesTaskData.forEach((valueDep) => {
            if (valueDep.projtask_id === value.id) {
              if (depsLoc === '') {
                depsLoc += valueDep.projtaskdepend_id
              } else {
                depsLoc += ',' + valueDep.projtaskdepend_id
              }
            }
          })
          value.dependences = depsLoc

          let indicatorsLoc = []
          this.projIndicatorsData.forEach((valueInd) => {
            if (valueInd.projtask_id === value.id) {
              indicatorsLoc.push({
                'date': valueInd.data,
                'name': valueInd.descricao,
                'tolltip': valueInd.dica,
                'iconClass': valueInd.icone,
              })
            }
          })
          // value.Indicators = indicatorsLoc
          // value.duracao = 0
          // value.progresso = null
          value.Indicators = indicatorsLoc
          // console.log('value.Indicators')
          // console.log(value.Indicators)
          // console.log('duracao')
          // console.log(value.duracao)
        })

        this.projMarkersData.forEach((value) => {
          value.day = value.data
          value.label = value.descricao
        })

        this.flagSubTarefa = false
        this.flagVisualTask = false
        this.updating = false
      })
    },


    recordDoubleClick(args){
      console.log('recordDoubleClick')
      // console.log(args.rowData.inicioexecFed)
      // console.log(args.rowData.fimexecFed)
      // console.log(args.rowData.taskData)

      this.projTaskData = args.rowData.taskData
      this.projTaskData.progresso = args.rowData.progresso

      if (Array.isArray(this.projTaskData.subtasks) && this.projTaskData.subtasks.length === 0) {
        this.flagSubTarefa = true;
      }

      this.showModalProjTask = true
      this.loadingResource = true

      this.novaDependencia = false
      this.novoRecurso = false
      this.novoMarker = false
      this.novoIndicator = false
      this.novaSubTask = false

      this.submittedTarefa = false
      this.submittedMarker = false
      this.submittedIndicator = false

      this.carregarResources()
    },


    carregarResources(){
      api.get(`${getBaseUrl()}api/projresources`, {
        params: { iddata: this.projTaskData.id }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.resourcesTaskData = res.data[0]
        this.dependencesTaskData = res.data[1]
        this.projIndicatorsData = res.data[2]
        // this.projSubTasksData = res.data[3]

        this.projSubTasksData = [].concat(...this.projTasksData.map(task => task.subtasks || []));


        this.loadingResource = false
      });
    },


    confProjTask(){
      console.log('confProjTask')
      console.log(this.projIndicatorData)
      this.submittedTarefa = true

      if (this.novoIndicator === true) {
        this.submittedIndicator = true

        if (this.projIndicatorData.descricao && this.projIndicatorData.icone && this.projIndicatorData.data) {
          this.showModalProjTask = false
          this.updating = true
          this.projIndicatorData.projtask_id = this.projTaskData.id
          api.post(`${getBaseUrl()}api/projindicator`, {
            'projIndicatorData': this.projIndicatorData
          }).then((res) => {
            console.log('then axios confProjTask')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }

      } else {
        if (this.projTaskData.codigo && this.projTaskData.descricao && this.projTaskData.inicio && this.projTaskData.fim) {
          this.showModalProjTask = false
          this.updating = true
          api.post(`${getBaseUrl()}api/projtask`, {
            'projTaskData': this.projTaskData,
            'flagsubtarefa': this.flagSubTarefa
          }).then((res) => {
            console.log('then axios confProjTask')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false

          })
        }
      }
    },

    toolbarClick(args){
      console.log('toolbarClick')
      console.log(args.item.id)
      if (args.item.id === "GanttExport_excelexport") {
        this.$refs.gantt.ej2Instances.excelExport();
      } else if (args.item.id === "GanttExport_csvexport") {
        this.$refs.gantt.ej2Instances.csvExport();
      } else if (args.item.id === "GanttExport_pdfexport") {
        var exportProperties = {
          fitToWidthSettings: {
            isFitToWidth: true
          },
        };
        this.$refs.gantt.ej2Instances.pdfExport(exportProperties);
      } else if (args.item.id === 'novaTarefa') {
        console.log('novaTarefa')
        this.projTaskData = {
          inicio: moment(new Date()).format("yyyy-MM-DDThh:mm"),
          fim: moment(new Date()).add(1, 'days').format("yyyy-MM-DDThh:mm")
        }
        this.novoIndicator = false
        this.novaDependencia = false
        this.novoRecurso = false
        this.novoMarker = false
        this.novaSubTask = false

        console.log('moment(new Date())')
        console.log(moment(new Date()).format("yyyy-MM-DDThh:mm"))


        this.submittedTarefa = false
        this.showModalProjTask = true
      } else if (args.item.id === 'abrirRecursos') {
        console.log('abrirRecursos')
        const routeData = this.$router.resolve(`/gpresources`)
        window.open(routeData.href, '_blank')
      } else if (args.item.id === 'abrirMarkers') {
        console.log('abrirMarkers')
        this.novoMarker = false
        this.showModalProjMarker = true
      } else if (args.item.id === 'downVisio') {
        console.log('downVisio')
        if (this.paramDownArqProj && this.paramDownArqProj.id) {
          window.open('https://drive.google.com/file/d/' + this.paramDownArqProj.descricao + '/view', '_blank')
        } else {
          Swal.fire({
            position: "center",
            icon: 'warning',
            text: 'Parâmetro não definido, favor definir na empresa o parâmetro -> Id do arquivo (gDrive) de gerenciamento de projetos',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          })
        }
        // this.novoMarker = false
        // this.showModalProjMarker = true
      }
    },

    formatStatus(status) {
      const map = {
        pending: { text: 'Pendente', color: '#faaabd' },
        inprocess: { text: 'Em Andamento', color: '#7cbcf6' },
        completed: { text: 'Concluído', color: '#34c18e' },
      };
      return map[status] || { text: 'Desconhecido', color: '#fff' };
    },

    toInputFormat(isoDate) {
      if (!isoDate) return null;
      const d = new Date(isoDate);
      return d.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>



    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div v-if="!updating" >

      <div class="col-lg-12 control-section">
        <div>
          <ejs-gantt ref='gantt'
                     id="GanttExport"
                     :dataSource="projTasksData"
                     :highlightWeekends='true'
                     :allowSelection='true'
                     :taskFields="taskFields"
                     :labelSettings="labelSettings"
                     :treeColumnIndex="0"
                     :columns="columns"
                     :splitterSettings="splitterSettings"
                     :resourceFields="resourceFields"
                     :resources="resourcesData"
                     :projectStartDate="projectStartDate"
                     :projectEndDate="projectEndDate"
                     :allowExcelExport="true"
                     :allowPdfExport="true"
                     :renderBaseline="true"
                     :toolbar= "toolbar"
                     :dateFormat="'dd/MM/yyyy'"
                     :eventMarkers= "projMarkersData"
                     :queryTaskbarInfo = "queryTaskbarInfo"
                     :recordDoubleClick= "recordDoubleClick"
                     @queryCellInfo="customizaCelula"
                     v-on:toolbarClick= "toolbarClick">
            <template #leftLabelTemplate="{data}">
              <div>
                {{ data.descricao }}
              </div>
            </template>

            <template #rightLabelTemplate="{data}">
              <div v-if="data.ganttProperties.resourceInfo">
                <span v-for="resource in data.ganttProperties.resourceInfo" :key="resource.id">
                  <img v-if="resource.img64"
                       :src="`data:image/png;base64,${resource.img64}`"
                       style="height: 40px;" :alt="resource.descricao"/>
                  <span style="marginLeft:5px;marginRight:5px">{{ resource.descricao }}</span>
                </span>
              </div>
            </template>
          </ejs-gantt>
        </div>
      </div>

    </div>



    <b-modal
        :title="projTaskData.id > 0 ? flagVisualTask === false ? flagSubTarefa === true ? `Editar SubTarefa (${ projTaskData.codigo })`:
             `Editar Tarefa (${ projTaskData.codigo })` : `Detalhes (${ projTaskData.codigo })` : 'Criando nova Tarefa'"
        id="modal-tarefa"
        size="xl"
        v-model="showModalProjTask"
        centered
        @hidden="carregarDados"
        hide-footer>

      <div>

        <div class="card-body">

          <div class="mt-0 mb-3">

            <b-button v-if="projTaskData.id > 0 && flagVisualTask === false" variant="outline-primary" class="ms-1" @click="confProjTask">
              <i class="bx bx-save font-size-16 align-middle me-2"></i>
              Salvar
            </b-button>

            <b-button v-if="projTaskData.id > 0 && flagVisualTask === false"
                      variant="danger" class="ms-1" @click="delProjTask(projTaskData.id)">
              <i class="bx bx-trash font-size-16 align-middle me-2"></i>
              {{ flagSubTarefa === true ? 'Excluir SubTarefa' : 'Excluir Tarefa'}}
            </b-button>
          </div>

          <div class="row mb-2">

            <div class="col-md-4">
              <label for="titulo">Título</label>
              <div class="position-relative">
                <input
                    id="titulo"
                    type="text"
                    v-model="projTaskData.titulo"
                    class="form-control"
                    placeholder="Título"
                    :disabled="novoIndicator || flagVisualTask === true"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.descricao}"/>
                <div v-if="submittedTarefa && !projTaskData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <label for="codigo"> {{ flagSubTarefa === true ? 'Código SubTarefa' : 'Código Tarefa'}}</label>
              <div class="position-relative">
                <input
                    id="codigo"
                    type="text"
                    v-model="projTaskData.codigo"
                    class="form-control"
                    placeholder="Código"
                    :disabled="novoIndicator || flagVisualTask === true || flagSubTarefa === true"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.codigo}"/>
                <div v-if="submittedTarefa && !projTaskData.codigo" class="invalid-feedback">
                  <span>Campo código obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label for="progresso">Progresso</label>
              <div class="position-relative">
                <input
                    id="progresso"
                    type="number"
                    max="100"
                    min="0"
                    v-model="projTaskData.progresso"
                    class="form-control text-center"
                    placeholder="Progresso"
                    :disabled="novoIndicator || flagVisualTask === true || flagSubTarefa === false"
                    :style="gradientProgressStyle"/>
                <span style="position: absolute; right: 24.8ch; top: 50%; transform: translateY(-50%); pointer-events: none; color: #555; font-size: 0.95rem">%</span>
              </div>
            </div>

          </div>

          <div class="row mb-2">

            <div class="col-md-8">
              <label for="descricao">Descrição</label>
              <div class="position-relative">
                <textarea
                    id="descricao"
                    type="text"
                    v-model="projTaskData.descricao"
                    class="form-control"
                    placeholder="Descreva a tarefa..."
                    rows="5"
                    :disabled="novoIndicator || flagVisualTask === true"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.descricao}"/>
                <div v-if="submittedTarefa && !projTaskData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>

            </div>

            <div class="row col-4 ms-auto">

              <div class="col-6">
                <div class="mb-3">
                  <label for="priorid">Prioridade <i class="bx bx-tag font-size-16 align-middle me-2" :style="iconPriorid"></i></label>
                  <select id="priorid" v-model="projTaskData.priorid" class="form-control" :disabled="flagVisualTask === true" style="padding-top: 2px; padding-bottom: 5px;">
                    <option value="baixa">Baixa</option>
                    <option value="normal">Normal</option>
                    <option value="media">Média</option>
                    <option value="alta">Alta</option>
                    <option value="critica">Crítica</option>
                  </select>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="stt">Status <i class="bx bx-tag font-size-16 align-middle me-2" :style="variantStatus"></i></label>
                  <select id="stt" v-model="projTaskData.status" class="form-control" :disabled="flagVisualTask === true" style="padding-top: 2px; padding-bottom: 5px;">
                    <option value="pending">Pendente</option>
                    <option value="inprocess">Em Andamento</option>
                    <option value="completed">Concluído</option>
                  </select>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex mb-2">
                  <label for="requerente" class="col-sm-3">Requerente: </label>
                  <div class="col-sm-9" style="padding-right: 10px">
                    <input
                        id="requerente"
                        type="text"
                        v-model="projTaskData.requerente"
                        class="form-control ms-2"
                        style="padding-top: 2px; padding-bottom: 5px;"
                        placeholder="Requerente"
                        :disabled="novoIndicator || flagVisualTask === true"
                        :class="{'is-invalid': submittedTarefa && !projTaskData.requerente}"/>
                    <div v-if="submittedTarefa && !projTaskData.requerente" class="invalid-feedback">
                      <span>Campo código obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex mb-3">
                  <label for="atribuido" class="col-sm-3">Atribuído a:</label>
                  <select id="atribuido" v-model="projTaskData.atribuido" class="form-control ms-2"
                          :disabled="flagVisualTask === true"
                          :class="{'is-invalid': submittedTarefa && !projTaskData.atribuido}"
                          style="padding-top: 2px; padding-bottom: 5px;">
                    <option :value="null" disabled>Selecione atribuição</option>
                    <option value="cliente">Cliente</option>
                    <option value="comercial">Comercial</option>
                    <option value="operacional">Operacional</option>
                    <option value="tecnologia">Tecnologia</option>
                  </select>
                  <div v-if="submittedTarefa && !projTaskData.atribuido" class="invalid-feedback">
                    <span>Campo código obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>
            </div>



          </div>

          <div class="row mb-2">

            <div class="col-md-3">
              <label for="inicio">Início Projeção</label>
              <div class="position-relative">
                <input
                    id="inicio"
                    type="datetime-local"
                    v-model="inicioLocal"
                    class="form-control"
                    placeholder="Início"
                    :disabled="novoIndicator || flagVisualTask === true"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.inicio}"/>
                <div v-if="submittedTarefa && !projTaskData.inicio" class="invalid-feedback">
                  <span>Campo início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="fim">Fim Projeção</label>
              <div class="position-relative">
                <input
                    id="fim"
                    type="datetime-local"
                    v-model="fimLocal"
                    class="form-control"
                    placeholder="Fim"
                    :disabled="novoIndicator || flagVisualTask === true"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.fim}"/>
                <div v-if="submittedTarefa && !projTaskData.fim" class="invalid-feedback">
                  <span>Campo fim obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>



            <div class="col-md-3">
              <label for="inicioexec">Início Execução</label>
              <div class="position-relative">
                <input
                    id="inicioexec"
                    type="datetime-local"
                    v-model="inicioexecLocal"
                    class="form-control"
                    placeholder="Início Execução"
                    :disabled="novoIndicator || flagVisualTask === true"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="fimexec">Fim Execução</label>
              <div class="position-relative">
                <input
                    id="fimexec"
                    type="datetime-local"
                    v-model="fimexecLocal"
                    class="form-control"
                    placeholder="Fim"
                    :disabled="novoIndicator || flagVisualTask === true"/>
              </div>
            </div>

          </div>

          <div class="row mb-2">
            <div class="col-12 text-center" v-if="loadingResource">
              <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
              </b-spinner>
              <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
              </b-spinner>
              <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
              </b-spinner>
            </div>
          </div>


          <div v-if="projTaskData.id > 0 && projTaskData.subtasks.length !== 0 && flagVisualTask === false"
               class="col-lg-12 mt-4">


                <b-tabs v-model="activeTab"
                        pills justified content-class="p-3 text-muted">

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-envelope"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">Sub-Tarefas</span>
                    </template>

                    <div class="d-flex mt-2">
                      <div v-if="projTaskData.id > 0" class="row col-6">
                        <b-button variant="outline-success" class="col-5" @click="newSubTarefa()">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova Sub-Tarefa
                        </b-button>

                        <b-button variant="outline-warning" class="col-6 ms-1" @click="novaSubTask = !novaSubTask">
                          <i class="bx bx-plus-circle font-size-16 aligsn-middle me-2"></i>
                          Assoc. Sub-Tarefa
                        </b-button>
                      </div>

                      <div class="col-6 ms-auto" style="position: relative; left: 13.5px" v-if="!loadingResource && novaSubTask">
                        <multiselect id="inputResource"
                                     @search-change="pesqSubTask"
                                     @select="escolheuSubTask"
                                     v-model="projSubTaskData.projsubtask_id"
                                     placeholder="Selecionar sub-tarefa"
                                     :options="dtListPesqSubTask"
                                     :searchable="true"
                                     label="descricao"
                                     track-by="descricao"
                                     value-prop="id"
                                     class="">
                          <template #option="slotProps">
                            <div style="min-width: 15%;">
                                  <span class="text-info">
                                    {{ slotProps.option.id }}
                                  </span>
                            </div>
                            <div style="min-width: 15%;">
                                  <span class="text-info">
                                    {{ slotProps.option.codigo }}
                                  </span>
                            </div>
                            <div style="min-width: 300px;">
                                  <span class="mx-4">
                                    {{ slotProps.option.descricao }}
                                  </span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <table v-if="!loadingResource"
                             class="table align-middle mb-0 mt-2 table-nowrap">
                        <thead class="table-light">
                        <tr>
<!--                          <th>ID</th>-->
                          <th >Código</th>
                          <th >Título</th>
                          <th class="text-center">Status</th>
                          <th >Prioridade</th>
                          <th >Requerente</th>
                          <th >Atribuido</th>
                          <th >Dt. Início</th>
                          <th >Dt. Fim</th>
                          <th class="text-center">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in projSubTasksData" :key="data.id">
<!--                          <td class="text-start">{{ data.id }}</td>-->
                          <td class="text-start"><!--{{ data.codigo }}-->
                            <a href="javascript: void(0);" class="text-body fw-bold" @click="editarSubTask(data.id)">
                              {{ data.codigo }}
                            </a></td>
                          <td class="text-start">{{ data.titulo }}</td>
<!--                          <td class="text-center">{{ data.status === 'completed' ? 'Concluído' : data.status === 'inprocess' ? 'Em Andamento' : 'Pendente'}} - {{ data.progresso + '%' }}</td>-->
                          <td class="text-center" :style="{color: formatStatus(data.status).color}">

                              {{ formatStatus(data.status).text }} - {{ data.progresso + '%' }}

                          </td>
                          <td class="text-start">{{ data.priorid }}</td>
                          <td class="text-start">{{ data.requerente }}</td>
                          <td class="text-start">{{ data.atribuido }}</td>
                          <td class="text-start">{{ formatDateTime(data.created_at) }}</td>
                          <td class="text-start">{{ formatDateTime(data.created_at) }}</td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-success" @click="detalhesSubTask(data.id)">
                                <i class="mdi mdi-eye d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-warning" @click="editarSubTask(data.id)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="delSubTask(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">Dependências</span>
                    </template>

                    <div class="d-flex mt-2">
                      <div v-if="projTaskData.id > 0" class="row col-6">
                        <b-button variant="outline-success" class="col-5" @click="novaDependencia = !novaDependencia">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova Dependência
                        </b-button>
                      </div>

                      <div class="col-6 ms-auto" style="position: relative; left: 13.5px" v-if="!loadingResource && novaDependencia">
                          <multiselect id="inputDependence"
                                       @search-change="pesqDependence"
                                       @select="escolheuDependence"
                                       v-model="dependenceData.projtaskdepend_id"
                                       placeholder="Selecionar dependência"
                                       :options="dtListPesqDependence"
                                       :searchable="true"
                                       label="descricao"
                                       track-by="descricao"
                                       value-prop="id"
                                       class="ms-0">
                            <template #option="slotProps">
                              <div style="min-width: 25%;">
                                <span class="text-info">
                                  {{ slotProps.option.id }}
                                </span>
                              </div>
                              <div style="min-width: 300px;">
                                <span class="mx-4">
                                  {{ slotProps.option.descricao }}
                                </span>
                              </div>
                            </template>
                          </multiselect>

                      </div>

                    </div>

                    <div class="row mt-2">
                      <table v-if="!loadingResource"
                             class="table align-middle mb-0 mt-2 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>ID</th>
                          <th>ID Tarefa</th>
                          <th>Descrição</th>
                          <th>Usuário</th>
                          <th>Data</th>
                          <th class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in dependencesTaskData" :key="data.id">
                          <td class="text-start">{{ data.id }}</td>
                          <td class="text-start">{{ data.projtaskdepend_id }}</td>
                          <td class="text-start">{{ data.descricao }}</td>
                          <td class="text-start">{{ data.created_by }}</td>
                          <td class="text-start">{{ formatDateTime(data.created_at) }}</td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-danger" @click="delDependence(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-envelope"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">Indicadores</span>
                    </template>

                    <div class="d-flex mt-2">
                      <div v-if="projTaskData.id > 0" class="row col-4">
                        <b-button disabled variant="outline-success" class="col-6" @click="novoIndicator = !novoIndicator">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Indicador
                        </b-button>
                      </div>

                      <div class="row col-8 ms-auto" style="position: relative; left: 13.5px" v-if="!loadingResource && novoIndicator">
                        <div class="col-6">
                          <input
                              id="descricao"
                              type="text"
                              v-model="projIndicatorData.descricao"
                              class="form-control"
                              placeholder="Descrição"
                              :class="{'is-invalid': submittedIndicator && !projIndicatorData.descricao}"/>
                          <div v-if="submittedIndicator && !projIndicatorData.descricao" class="invalid-feedback">
                            <span>Campo descrição obrigatório, favor preencher.</span>
                          </div>
                        </div>

                        <div class="col-3">
                          <select id="icone" v-model="projIndicatorData.icone" class="form-control"
                                  :class="{'is-invalid': submittedIndicator && !projIndicatorData.icone}">
                            <option :value="null" disabled selected>Ícone</option>
                            <option value="description e-icons">Losango</option>
                            <option value="okIcon e-icons">Ok</option>
                          </select>
                          <div v-if="submittedIndicator && !projIndicatorData.icone" class="invalid-feedback">
                            <span>Campo ícone obrigatório, favor preencher.</span>
                          </div>
                        </div>


                        <div class="col-3">
                          <input
                              id="data"
                              type="date"
                              v-model="projIndicatorData.data"
                              class="form-control"
                              placeholder="Início"
                              :class="{'is-invalid': submittedIndicator && !projIndicatorData.data}"/>
                          <div v-if="submittedIndicator && !projIndicatorData.data" class="invalid-feedback">
                            <span>Campo início obrigatório, favor preencher.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <table v-if="!loadingResource"
                             class="table align-middle mb-0 mt-2 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>ID</th>
                          <th>Descrição</th>
                          <th>Ícone</th>
                          <th>Usuário</th>
                          <th>Data</th>
                          <th class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in projIndicatorsData" :key="data.id">
                          <td class="text-start">{{ data.id }}</td>
                          <td class="text-start">{{ data.descricao }}</td>
                          <td class="text-start">{{ data.icone }}</td>
                          <td class="text-start">{{ data.created_by }}</td>
                          <td class="text-start">{{ formatDateTime(data.created_at) }}</td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-danger" @click="delIndicator(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">Recursos</span>
                    </template>

                    <div class="d-flex mt-2">
                      <div v-if="projTaskData.id > 0" class="row col-6">
                        <b-button variant="outline-success" class="col-5" @click="novoRecurso = !novoRecurso">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Recurso
                        </b-button>
                      </div>

                      <div class="col-6 ms-auto" style="position: relative; left: 13.5px" v-if="!loadingResource && novoRecurso">

                        <multiselect id="inputRecurso"
                                     @search-change="pesqResource"
                                     @select="escolheuResource"
                                     v-model="resourceData.resource_id"
                                     placeholder="Selecionar recurso"
                                     :options="dtListPesqResource"
                                     :searchable="true"
                                     label="descricao"
                                     track-by="descricao"
                                     value-prop="id"
                                     class="ms-0">
                          <template #option="slotProps">
                            <div style="min-width: 25%;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                            </div>
                            <div style="min-width: 300px;">
                              <span class="mx-4">
                                {{ slotProps.option.descricao }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                      </div>

                    </div>

                    <div class="row mt-2">
                      <table v-if="!loadingResource"
                             class="table align-middle mb-0 mt-2 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>ID</th>
                          <th>Descrição</th>
                          <th>Usuário</th>
                          <th>Data</th>
                          <th class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in resourcesTaskData" :key="data.id">
                          <td class="text-start">{{ data.id }}</td>
                          <td class="text-start">{{ data.descricao }}</td>
                          <td class="text-start">{{ data.created_by }}</td>
                          <td class="text-start">{{ formatDateTime(data.created_at) }}</td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-danger" @click="delResource(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                </b-tabs>


          </div>

<!--          <div class="row mt-2 mb-2">

            <div class="col-sm-12" v-if="!loadingResource && novoRecurso">
              <div class="mb-3">

                <span class="font-size-13">Novo Recurso </span>
                <multiselect id="inputResource"
                             @search-change="pesqResource"
                             @select="escolheuResource"
                             v-model="resourceData.resource_id"
                             placeholder="Selecionar recurso"
                             :options="dtListPesqResource"
                             :searchable="true"
                             label="descricao"
                             track-by="descricao"
                             value-prop="id"
                             class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 25%;">
                      <span class="text-info">
                        {{ slotProps.option.id }}
                      </span>
                    </div>
                    <div style="min-width: 300px;">
                      <span class="mx-4">
                        {{ slotProps.option.descricao }}
                      </span>
                    </div>
                  </template>
                </multiselect>

              </div>
            </div>

          </div>-->

<!--          <div class="row mt-2 mb-2">

            <div class="col-sm-12" v-if="!loadingResource && novaDependencia">
              <div class="mb-3">

                <span class="font-size-13">Nova Dependência </span>
                <multiselect id="inputDependence"
                             @search-change="pesqDependence"
                             @select="escolheuDependence"
                             v-model="dependenceData.projtaskdepend_id"
                             placeholder="Selecionar dependência"
                             :options="dtListPesqDependence"
                             :searchable="true"
                             label="descricao"
                             track-by="descricao"
                             value-prop="id"
                             class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 25%;">
                      <span class="text-info">
                        {{ slotProps.option.id }}
                      </span>
                    </div>
                    <div style="min-width: 300px;">
                      <span class="mx-4">
                        {{ slotProps.option.descricao }}
                      </span>
                    </div>
                  </template>
                </multiselect>

              </div>
            </div>

          </div>-->

<!--          <div class="row mt-2 mb-2" v-if="!loadingResource && novoIndicator">

            <div class="col-md-4">
              <label for="descricao">Novo Indicador</label>
              <div class="position-relative">
                <input
                    id="descricao"
                    type="text"
                    v-model="projIndicatorData.descricao"
                    class="form-control"
                    placeholder="Descrição"
                    :class="{'is-invalid': submittedIndicator && !projIndicatorData.descricao}"/>
                <div v-if="submittedIndicator && !projIndicatorData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="icone">Ícone</label>
                <select id="icone" v-model="projIndicatorData.icone" class="form-control"
                        :class="{'is-invalid': submittedIndicator && !projIndicatorData.icone}">
                  <option value="description e-icons">Losango</option>
                  <option value="okIcon e-icons">Ok</option>
                </select>
                <div v-if="submittedIndicator && !projIndicatorData.icone" class="invalid-feedback">
                  <span>Campo ícone obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <label for="data">Data</label>
              <div class="position-relative">
                <input
                    id="data"
                    type="date"
                    v-model="projIndicatorData.data"
                    class="form-control"
                    placeholder="Início"
                    :class="{'is-invalid': submittedIndicator && !projIndicatorData.data}"/>
                <div v-if="submittedIndicator && !projIndicatorData.data" class="invalid-feedback">
                  <span>Campo início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
            

          </div>-->

<!--          <div class="row mt-2 mb-2">

            <div class="col-sm-12" v-if="!loadingResource && novaSubTask">
              <div class="mb-3">

                <span class="font-size-13">Nova Sub-Tarefa </span>
                <multiselect id="inputResource"
                             @search-change="pesqSubTask"
                             @select="escolheuSubTask"
                             v-model="projSubTaskData.projsubtask_id"
                             placeholder="Selecionar sub-tarefa"
                             :options="dtListPesqSubTask"
                             :searchable="true"
                             label="descricao"
                             track-by="descricao"
                             value-prop="id"
                             class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 15%;">
                      <span class="text-info">
                        {{ slotProps.option.id }}
                      </span>
                    </div>
                    <div style="min-width: 15%;">
                      <span class="text-info">
                        {{ slotProps.option.codigo }}
                      </span>
                    </div>
                    <div style="min-width: 300px;">
                      <span class="mx-4">
                        {{ slotProps.option.descricao }}
                      </span>
                    </div>
                  </template>
                </multiselect>

              </div>
            </div>

          </div>-->

        </div>


        <div v-if="flagVisualTask === false" class="text-end mt-5">
          <b-button variant="light" @click="showModalProjTask = false; novoRecurso = false; novaDependencia = false; novoIndicator = false;">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="success" class="ms-1" @click="confProjTask">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </div>

    </b-modal>


    <b-modal size="xl"
             title="Marcadores"
             v-model="showModalProjMarker" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-2">
            <div class="row mt-2">
              <span>Marcadores do Projeto</span>
              <table v-if="!loadingMarkers"
                     class="table align-middle mb-0 mt-2 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>ID</th>
                  <th>Descrição</th>
                  <th>Data</th>
                  <th>Usuário</th>
                  <th>Criado em</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in projMarkersData" :key="data.id">
                  <td class="text-start">{{ data.id }}</td>
                  <td class="text-start">{{ data.descricao }}</td>
                  <td class="text-start">{{ formatDate(data.data) }}</td>
                  <td class="text-start">{{ data.created_by }}</td>
                  <td class="text-start">{{ formatDateTime(data.created_at) }}</td>
                  <td class="text-end">
                    <div class="button-items">
                      <b-button variant="outline-warning" @click="editMarker(data)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>
                      <b-button variant="outline-danger" @click="delMarker(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>


          <div class="row mb-2 mt-5" v-if="!loadingMarkers && novoMarker">

            <div class="col-md-6">
              <label for="descricao">Descrição</label>
              <div class="position-relative">
                <input
                    id="descricao"
                    type="text"
                    v-model="projMarkerData.descricao"
                    class="form-control"
                    placeholder="Descrição"
                    :class="{'is-invalid': submittedMarker && !projMarkerData.descricao}"/>
                <div v-if="submittedMarker && !projMarkerData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label for="data">Data</label>
              <div class="position-relative">
                <input
                    id="data"
                    type="date"
                    v-model="projMarkerData.data"
                    class="form-control"
                    placeholder="Data"
                    :class="{'is-invalid': submittedMarker && !projMarkerData.data}"/>
                <div v-if="submittedMarker && !projMarkerData.data" class="invalid-feedback">
                  <span>Campo data obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalProjMarker = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button v-if="!novoMarker" type="submit" variant="warning" class="ms-1" @click="novoMarker = !novoMarker">
            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
            Novo Marcador
          </b-button>
          <b-button v-if="novoMarker" type="submit" variant="success" class="ms-1" @click="confProjMarker">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </div>

    </b-modal>


  </Layout>
</template>

<style scoped>
#ToolbarTemplate  .e-quickfilter::before {
  content: "\e7ee"
}
.fabric #ToolbarTemplate /deep/  .e-quickfilter::before,
.highcontrast #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e21c';
}
.bootstrap #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e946';
}
.bootstrap4 #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e714';
}
.tailwind #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e71b';
}
.fluent #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2 #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2-dark #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2-highcontrast #ToolbarTemplate /deep/  .e-quickfilter::before
{
  content: '\e7f7';
}

</style>
